import * as moment from "moment";
import { INPUT_TYPE } from "../../constants/Constant";

export const APPLICABLE_TO = {
    NONE: "none",
    ALL: "all",
    SELECTED: "selected"
}
export const WEEK_DAY_STATUS_CONSTANTS = {
    OFF_DAY: "OFF_DAY",
    WEEK_DAY: "WEEK_DAY",
    HALF_DAY: "HALF_DAY",
    REST_DAY: "REST_DAY",
    HOLIDAY: "HOLIDAY"
}

export const WEEK_DAY_STATUS = [
    { value: WEEK_DAY_STATUS_CONSTANTS.OFF_DAY, label: "Off Day" },
    { value: WEEK_DAY_STATUS_CONSTANTS.WEEK_DAY, label: "Regular Day" },
    { value: WEEK_DAY_STATUS_CONSTANTS.HALF_DAY, label: "Half Day" },
    { value: WEEK_DAY_STATUS_CONSTANTS.REST_DAY, label: "Rest Day" },
    { value: WEEK_DAY_STATUS_CONSTANTS.HOLIDAY, label: "Holiday" }
];

export const MONTHLY_WHEN_CONSTANT = {
    ALL_WEEK: "ALL_WEEK",
    FIRST_WEEK: "FIRST_WEEK",
    SECOND_WEEK: "SECOND_WEEK",
    THIRD_WEEK: "THIRD_WEEK",
    FOURTH_WEEK: "FOURTH_WEEK",
    FIFTH_WEEK: "FIFTH_WEEK",
    SIXTH_WEEK: "SIXTH_WEEK",
    ALTERNATE_ODD_WEEK: "ALTERNATE_ODD_WEEK",
    ALTERNATE_EVEN_WEEK: "ALTERNATE_EVEN_WEEK"
}

export const WEEK_MONTHLY_WHEN = [
    { value: MONTHLY_WHEN_CONSTANT.ALL_WEEK, label: "All" },
    { value: MONTHLY_WHEN_CONSTANT.FIRST_WEEK, label: "1st Week", displayMsg: "Only days in the 1st week will be considered" },
    { value: MONTHLY_WHEN_CONSTANT.SECOND_WEEK, label: "2nd Week" , displayMsg: "Only days in the 2nd week will be considered"},
    { value: MONTHLY_WHEN_CONSTANT.THIRD_WEEK, label: "3rd Week" , displayMsg: "Only days in the 3rd week will be considered"},
    { value: MONTHLY_WHEN_CONSTANT.FOURTH_WEEK, label: "4th Week", displayMsg: "Only days in the 4th week will be considered" },
    { value: MONTHLY_WHEN_CONSTANT.FIFTH_WEEK, label: "5th Week", displayMsg: "Only days in the 5th week will be considered" },
    { value: MONTHLY_WHEN_CONSTANT.SIXTH_WEEK, label: "6th Week", displayMsg: "Only days in the 6th week will be considered" },
    { value: MONTHLY_WHEN_CONSTANT.ALTERNATE_ODD_WEEK, label: "Alternate(1st, 3rd, 5th)", displayMsg: "Only days in the 1st, 3rd and 5th week will be considered" },
    { value: MONTHLY_WHEN_CONSTANT.ALTERNATE_EVEN_WEEK, label: "Alternate(2nd, 4th, 6th)", displayMsg: "Only days in the 2nd, 4th, 6th week should be considered" }
];


export const WEEK_DAYS = [
    {
        id: "MONDAY",
        name: "Monday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("09:00 AM", "hh:mm A")
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("06:00 PM", "hh:mm A")
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Regular Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "TUESDAY",
        name: "Tuesday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("09:00 AM", "hh:mm A")
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("06:00 PM", "hh:mm A")
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Regular Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "WEDNESDAY",
        name: "Wednesday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("09:00 AM", "hh:mm A")
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("06:00 PM", "hh:mm A")
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Regular Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "THURSDAY",
        name: "Thursday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("09:00 AM", "hh:mm A")
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("06:00 PM", "hh:mm A")
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Regular Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "FRIDAY",
        name: "Friday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("09:00 AM", "hh:mm A")
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: moment("06:00 PM", "hh:mm A")
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Regular Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "SATURDAY",
        name: "Saturday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: "00:00"
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: "00:00"
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Off Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    },
    {
        id: "SUNDAY",
        name: "Sunday",
        inTime: {
            id: "inTime",
            title: "From",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: "00:00"
        },
        outTime: {
            id: "outTime",
            title: "To",
            hideLabel: true,
            type: "date-time-input",
            validation: [["required"]],
            is12Hour: true,
            hideFooterDateTime: false,
            value: "00:00"
        },
        workingStatus: {
            id: "workingStatus",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_DAY_STATUS,
            value: "Off Day"
        },
        when: {
            id: "when",
            type: INPUT_TYPE.DROPDOWN,
            options: WEEK_MONTHLY_WHEN,
            value: "All"
        }
    }
];

class ShiftUtils {
    static getDefaultFromAndToTime(tenantWorkWeek) {
        const defaultFromAndToTime = {
            from: moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 }),
            to: moment().set({ hour: 18, minute: 0, second: 0, millisecond: 0 })
        }

        if (tenantWorkWeek?.length > 0) {
            const workDay = tenantWorkWeek.find((day) => day.isWorkingDay);
            if (workDay) {
                defaultFromAndToTime.from = moment(workDay.startTime, "hh:mm A");
                defaultFromAndToTime.to = moment(workDay.endTime, "hh:mm A");
            }
        }

        return defaultFromAndToTime;
    }

    static getDefaultShiftMarginTime() {
        const defaultShiftMarginTime = {
            before: moment().set({ hour: 3, minute: 0, second: 0, millisecond: 0 }),
            after: moment().set({ hour: 3, minute: 0, second: 0, millisecond: 0 })
        }

        return defaultShiftMarginTime;
    }

    static getRequiredPresentHrs(from, to) {
        const requiredPresentHrs = {
            full: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            half: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        }

        if (from instanceof moment && to instanceof moment) {
            const duration = moment.duration(to.diff(from));
            const fullHrs = moment().set({ hour: duration.asHours(), minute: duration.asMinutes() % 60, second: 0, millisecond: 0 });
            requiredPresentHrs.full = fullHrs;

            const minutes = (fullHrs.get("hours") * 60 + fullHrs.get("minutes")) / 2;
            const halfHrs = Math.floor(minutes / 60);
            const halfMinutes = Math.floor(minutes % 60);
            requiredPresentHrs.half = moment().set({ hour: halfHrs, minute: halfMinutes, second: 0, millisecond: 0 });
        }

        return requiredPresentHrs;
    }

    static getHalfDayHrsForGivenFullDay(fullHrs) {
        if (fullHrs instanceof moment) {
            const minutes = (fullHrs.get("hours") * 60 + fullHrs.get("minutes")) / 2;
            const halfHrs = Math.floor(minutes / 60);
            const halfMinutes = Math.floor(minutes % 60);
            return moment().set({ hour: halfHrs, minute: halfMinutes, second: 0, millisecond: 0 });
        }
    }

    static get24HrsTime(time) {
        if (time instanceof moment) {
            return time.format("HH:mm");
        }

        return time;
    }

    static getEmployeeDetailsConfig(shift, showFirst = 3) {
        let employeesDetails = "None";

        if (shift.applicableTo) {
            employeesDetails = "All";
        } else {
            const employees = shift.employeeDetails;
            if (employees?.length > 0) {
                employeesDetails = employees.slice(0, showFirst).map((e) => `${e.firstName} ${e.lastName}`).join(", ");
                employeesDetails += employees.length > showFirst ? `... and ${employees.length - showFirst} more` : "";
            }
        }

        return employeesDetails;
    }

    static getMembersWithoutShift(shifts, users, shiftId) {
        const members = [];
        if (users?.length > 0) {
            users.forEach((user) => {
                let isShiftAssignedToUser = false;

                if (shifts?.length > 0) {
                    shifts.forEach((shift) => {
                        const shiftMembers = shift.employees?.map((e) => e.employeeId);
                        if (shift.id !== shiftId && shiftMembers?.includes(user.userId)) {
                            isShiftAssignedToUser = true;
                        }
                    });
                }

                if (!user.isTerminated && !isShiftAssignedToUser) {
                    members.push({
                        value: user.userId,
                        label: user.name
                    });
                }
            });
        }

        return members;
    }

    static getPaginatedData(originalData, currentPage, pageSize = 20) {
        const paginatedData = {
            data: [],
            currentPage: currentPage,
            totalPageCount: 0
        };

        if (originalData?.length > 0) {
            paginatedData.totalPageCount = Math.ceil(originalData.length / pageSize);
            paginatedData.currentPage = paginatedData.totalPageCount < currentPage ? paginatedData.totalPageCount : currentPage;

            const start = (paginatedData.currentPage - 1) * pageSize;
            const end = start + pageSize;
            paginatedData.data = originalData.slice(start, end);
        }

        return paginatedData;
    }

    static isApplicableToAllShiftExist(shifts) {
        let applicableToAll = false;

        if (shifts?.length > 0) {
            shifts.forEach((shift) => {
                if (shift.applicableTo) {
                    applicableToAll = shift.applicableTo;
                }
            });
        }

        return applicableToAll;
    }

    static isDuplicateShiftName(shiftName, currentShift, shifts) {
        let isDuplicate = false;

        if (shifts?.length > 0) {
            shifts.forEach((shift) => {
                if (shift.id !== currentShift?.id && String(shiftName).toLowerCase() === String(shift.name).toLowerCase()) {
                    isDuplicate = true;
                }
            });
        }

        return isDuplicate;
    }

    static isShiftWithMembersExist(shifts, payload) {
        let exists = false;
        const filteredShifts = shifts?.filter((shift) => shift.id !== payload.id);
        const allMembersShifts = filteredShifts?.filter((shift) => shift.applicableTo);
        const selectedMembersShifts = filteredShifts?.filter((shift) => shift.employees?.length > 0);

        if (payload.applicableTo && (allMembersShifts?.length > 0 || selectedMembersShifts?.length > 0)) {
            exists = true;
        } else {
            if (payload.employees?.length > 0 && allMembersShifts?.length > 0) {
                exists = true;
            } else {
                payload.employees?.some((user) => {
                    selectedMembersShifts?.some((shift) => {
                        const shiftMembers = shift.employees?.map((e) => e.employeeId);
                        if (shiftMembers.includes(user)) {
                            exists = true;
                            return;
                        }
                    });
                });
            }
        }

        return exists;
    }

    static getShiftByUserId(userId, shifts) {
        let userShift = null;
        if (userId && Array.isArray(shifts)) {
            for(let shift of  shifts) {
                if (shift.applicableTo || shift.employees?.find((e) => e.employeeId === userId)) {
                    userShift = shift;
                    break;
                }
            }
        }

        return userShift;
    }

    static convert24HrsTimeTo12Hrs(t) {
        try{
            return moment(t, "hh:mm a").format("hh:mm A")
        }catch(err) {
            return t;
        }
    }
}

export default ShiftUtils;
